import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Schedule } from '../../../../domain/schedule.model';
import { ScheduleAction } from '../../store/schedule.action';
import { ScheduleState } from '../../store/schedule.state';

@Component({
    selector: 'app-timetable',
    templateUrl: './timetable.component.html',
    styleUrls: ['./timetable.component.scss']
})
export class TimetableComponent implements OnInit {

    @Select(ScheduleState.getList) list$: Observable<Schedule[]>;
    timestamp = 'yyyy-MM-dd HH:mm';

    constructor(private store: Store) {
    }

    ngOnInit(): void {
    }

    openTimetableEditAside() {
        this.store.dispatch(new ScheduleAction.OpenEditDialog(null));
    }

    delete(id): void {
        this.store.dispatch(new ScheduleAction.Delete(id));
    }

    edit(item: Schedule) {
        this.store.dispatch(new ScheduleAction.OpenEditDialog(item));
    }
}
